// Copyright (c) 2016 Deere & Company

import FailurePanelContainer from './failure-panel-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.track.claim,
    downTimeCollection: state.claims.downTime,
    failureModes: state.claims.track.failureModes,
    formValidation: state.claims.track.formValidation,
    goodsInstallationVatOptions: state.claims.goodsInstallationVatOptions,
    isEditable: state.claims.track.isEditable,
    isValidClaim: state.claims.track.isValidClaim,
    lugHeightUnitCollection: state.claims.track.lugHeightUnitCollection,
    partsUseUnitCollection: state.claims.partUseUnits
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(FailurePanelContainer);



// WEBPACK FOOTER //
// ./src/claim/track/components/failure-panel/index.js